// @flow
import React, { Component } from "react";
import { Motion, spring } from "react-motion";
import { SizeMe } from "react-sizeme";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import pinIcon from "../../../images/breachroom-pin.svg";
import BreachPopup from "./BreachPopup/BreachPopup";
import container from "../../../styles/container.module.css";
import styles from "./Hero.module.css";

type Props = {
  breaches: Array<{ node: PrismicBreach }>,
  isMapFullscreen: boolean
};

type State = {
  popupInfo: ?PrismicBreach,
  viewport: MapGLViewport
};

class Hero extends Component<Props, State> {
  state = {
    popupInfo: null,
    viewport: {
      width: 420,
      height: 420,
      latitude: 37,
      longitude: -37,
      zoom: 2
    }
  };

  setPopup = (breach: PrismicBreach) => {
    this.setState({
      popupInfo: breach
    });
  };

  renderBreachMarker = (breach: { node: PrismicBreach }) => {
    const {
      node: { data }
    } = breach;
    return (
      <Marker
        key={`${data.location.latitude} ${data.location.longitude}`}
        latitude={data.location.latitude}
        longitude={data.location.longitude}
      >
        <img
          src={pinIcon}
          alt={data.title.text}
          className={styles.mapMarker}
          onClick={() => this.setPopup(breach.node)}
        />
      </Marker>
    );
  };

  get renderPopup() {
    const { popupInfo } = this.state;
    const { isMapFullscreen } = this.props;
    return (
      popupInfo &&
      isMapFullscreen && (
        <Popup
          tipSize={5}
          anchor="top"
          longitude={popupInfo.data.location.longitude}
          latitude={popupInfo.data.location.latitude}
          onClose={() => this.setState({ popupInfo: null })}
          closeOnClick
        >
          <BreachPopup breach={popupInfo} />
        </Popup>
      )
    );
  }

  render() {
    const { viewport } = this.state;
    const { breaches, isMapFullscreen } = this.props;
    return (
      <Motion
        style={{
          x: spring(isMapFullscreen ? 100 : 0, {
            stiffness: 250,
            damping: 20
          })
        }}
      >
        {({ x }) => (
          <div className={styles.hero} style={{ height: `${x}vh` }}>
            <SizeMe>
              {({ size }) => (
                <div className={styles.map} style={{ height: `${x}vh` }}>
                  <ReactMapGL
                    {...viewport}
                    width={size.width}
                    height={isMapFullscreen ? window.innerHeight : 420}
                    onViewportChange={nextViewport =>
                      this.setState({ viewport: nextViewport })
                    }
                    mapboxApiAccessToken="pk.eyJ1IjoibXVrZWFsaWNpb3VzIiwiYSI6ImNqazhzenNiZDF0YXIzcG5jOWt5bzlxMDMifQ.UZVPfZw_s-yWw2Zf1yIazw"
                  >
                    {breaches.map(this.renderBreachMarker)}
                    {this.renderPopup}
                  </ReactMapGL>
                </div>
              )}
            </SizeMe>
            <div
              className={styles.content}
              style={{ display: isMapFullscreen ? `none` : `block` }}
            >
              <div className={`${styles.container} ${container.default}`}>
                <h1 className={styles.headline}>
                  <span className={styles.highlight}>Breachroom:</span> a
                  collection of recent cyber attacks and data breaches.
                </h1>
              </div>
            </div>
          </div>
        )}
      </Motion>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Landing/Hero/Hero.js